// Program types enum to replace multiple boolean checks
export const PROGRAM_TYPES = {
  HIGH_SCHOOL: 'HIGH_SCHOOL',
  MIDDLE_SCHOOL: 'MIDDLE_SCHOOL',
  MIDDLE_SCHOOL_TIER_2: 'MIDDLE_SCHOOL_TIER_2',
  ELEMENTARY: 'ELEMENTARY',
  ELEMENTARY_TIER_2: 'ELEMENTARY_TIER_2',
  UNKNOWN: 'UNKNOWN',
}

/**
 * Determines the current program type based on the URL pathname
 * @returns {string} The program type from PROGRAM_TYPES enum
 */
export const getCurrentProgram = () => {
  const pathname = window.location.pathname

  // Handle undefined or null pathname
  if (!pathname) {
    return PROGRAM_TYPES.UNKNOWN
  }

  if (
    pathname.includes('/product/high-school') ||
    pathname.includes('/high-school') ||
    pathname.includes('/dashboard/grades-9-12')
  ) {
    return PROGRAM_TYPES.HIGH_SCHOOL
  } else if (
    pathname.includes('/product/middle-school/lessons/tier-2') ||
    pathname.includes('/middle-school/lessons/tier-2') ||
    pathname.includes('/dashboard/grades-6-8/tier-2')
  ) {
    return PROGRAM_TYPES.MIDDLE_SCHOOL_TIER_2
  } else if (
    pathname.includes('/product/middle-school') ||
    pathname.includes('/middle-school') ||
    pathname.includes('/dashboard/grades-6-8')
  ) {
    return PROGRAM_TYPES.MIDDLE_SCHOOL
  } else if (
    pathname.includes('/product/elementary/lessons/tier-2') ||
    pathname.includes('/elementary/lessons/tier-2') ||
    pathname.includes('/dashboard/grades-k-5/tier-2')
  ) {
    return PROGRAM_TYPES.ELEMENTARY_TIER_2
  } else if (
    pathname.includes('/product/elementary') ||
    pathname.includes('/elementary') ||
    pathname.includes('/dashboard/grades-k-5')
  ) {
    return PROGRAM_TYPES.ELEMENTARY
  }

  return PROGRAM_TYPES.UNKNOWN
}

/**
 * Helper function to check if the current program is high school
 * @returns {boolean} True if current program is high school
 */
export const isHighSchoolProgram = () => {
  return getCurrentProgram() === PROGRAM_TYPES.HIGH_SCHOOL
}

/**
 * Helper function to check if the current program is middle school
 * @returns {boolean} True if current program is middle school
 */
export const isMiddleSchoolProgram = () => {
  return getCurrentProgram() === PROGRAM_TYPES.MIDDLE_SCHOOL
}

/**
 * Helper function to check if the current program is elementary
 * @returns {boolean} True if current program is elementary
 */
export const isElementaryProgram = () => {
  return getCurrentProgram() === PROGRAM_TYPES.ELEMENTARY
}

/**
 * Helper function to check if the current program is middle school tier 2
 * @returns {boolean} True if current program is middle school tier 2
 */
export const isMiddleSchoolTier2Program = () => {
  return getCurrentProgram() === PROGRAM_TYPES.MIDDLE_SCHOOL_TIER_2
}

/**
 * Helper function to check if the current program is elementary tier 2
 * @returns {boolean} True if current program is elementary tier 2
 */
export const isElementaryTier2Program = () => {
  return getCurrentProgram() === PROGRAM_TYPES.ELEMENTARY_TIER_2
}

/**
 * Gets the appropriate theme name for the current program
 * @returns {string} Theme name for the current program
 */
export const getProgramTheme = () => {
  const program = getCurrentProgram()

  switch (program) {
    case PROGRAM_TYPES.ELEMENTARY:
    case PROGRAM_TYPES.ELEMENTARY_TIER_2:
      return 'gradek5'
    case PROGRAM_TYPES.MIDDLE_SCHOOL:
    case PROGRAM_TYPES.MIDDLE_SCHOOL_TIER_2:
      return 'gradems'
    case PROGRAM_TYPES.HIGH_SCHOOL:
      return 'gradehs'
    default:
      return 'gradehs' // default to high school
  }
}

export const ELEMENTARY_URL = '/product/elementary/'
export const MIDDLE_SCHOOL_URL = '/product/middle-school/'
export const ELEMENTARY_INDIVIDUAL_RESOURCE_PATH = `${ELEMENTARY_URL}lessons/tier-2`
export const MIDDLE_SCHOOL_INDIVIDUAL_RESOURCE_PATH = `${MIDDLE_SCHOOL_URL}lessons/tier-2`
